import { hasErrors } from "../lib/utils.js";
import * as React$1 from "react";
//#region src/smart-components/field-errors.ts
const isErrorRecord = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
const isCompoundFieldErrorState = (errors) => isErrorRecord(errors) && !React$1.isValidElement(errors) && isErrorRecord(errors.parts);
const resolveCompoundFieldErrors = (errors, partOrder) => {
	if (!isCompoundFieldErrorState(errors)) {
		const hasError = hasErrors(errors);
		return {
			firstInvalidPart: void 0,
			hasError,
			message: hasError ? errors : void 0,
			parts: {}
		};
	}
	const parts = {};
	for (const part of partOrder) if (hasErrors(errors.parts[part])) parts[part] = errors.parts[part];
	const firstInvalidPart = partOrder.find((part) => part in parts);
	return {
		firstInvalidPart,
		hasError: hasErrors(errors.message) || firstInvalidPart !== void 0,
		message: hasErrors(errors.message) ? errors.message : void 0,
		parts
	};
};
const messageFromUnknownFieldError = (error) => {
	if (typeof error === "string") return error || void 0;
	if (Array.isArray(error)) {
		for (const value of error) {
			const message = messageFromUnknownFieldError(value);
			if (message) return message;
		}
		return;
	}
	if (!isErrorRecord(error)) return void 0;
	if (typeof error.message === "string" && error.message) return error.message;
	const rootMessage = messageFromUnknownFieldError(error.root);
	if (rootMessage) return rootMessage;
	const typeMessage = messageFromUnknownFieldError(error.types);
	if (typeMessage) return typeMessage;
	for (const [key, value] of Object.entries(error)) {
		if (key === "message" || key === "ref" || key === "root" || key === "type" || key === "types") continue;
		const nestedMessage = messageFromUnknownFieldError(value);
		if (nestedMessage) return nestedMessage;
	}
};
const compoundFieldErrorsFromUnknown = (error, partOrder) => {
	if (!isErrorRecord(error)) return messageFromUnknownFieldError(error);
	const partSet = new Set(partOrder);
	const parts = {};
	for (const part of partOrder) {
		const message = messageFromUnknownFieldError(error[part]);
		if (message) parts[part] = message;
	}
	const message = messageFromUnknownFieldError(Object.fromEntries(Object.entries(error).filter(([key]) => !partSet.has(key))));
	if (!Object.keys(parts).length) return message;
	return {
		message,
		parts
	};
};
//#endregion
export { compoundFieldErrorsFromUnknown, isCompoundFieldErrorState, messageFromUnknownFieldError, resolveCompoundFieldErrors };

//# sourceMappingURL=field-errors.js.map